export default __webpack_public_path__ + "static/media/humboldt_thumb.2212c94f.jpeg";